module.exports = __webpack_public_path__ + "static/img/stay-option-icon-mountainview.a023aa28.svg";